import React from "react";

const FAQ = () => {
  return (
    <>
      {/* FAQ SECTION START */}
      <div className="bg-light">
        <div className="container-xxl py-5 ">
          <div className="container">
            <div
              className="text-center pb-5 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <h6 className="section-title bg-light text-center text-primary px-3">
                Questions
              </h6>
              <h1 className="mb-3">Everything You Need To Know</h1>
              <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>
                Find answers to common questions about our international
                recruitment process and documentation requirements.
              </p>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-10 col-xl-8">
                <div className="accordion" id="accordionFAQ">
                  {[
                    {
                      q: "What does an overseas recruitment agency in Pakistan do for Saudi Arabia jobs?",
                      a: "We bridge the gap between Saudi employers and Pakistani talent. Our services include sourcing candidates, conducting trade tests, managing medical appointments, and navigating the complete visa stamping process.",
                    },
                    {
                      q: "How can I apply for a job in Saudi Arabia?",
                      a: "You can visit our office with your updated CV, original passport, and educational certificates. Our technical team will evaluate your skills against current vacancies and guide you through the next steps.",
                    },
                    {
                      q: "How long does the recruitment process take?",
                      a: "On average, the process takes 3 to 8 weeks. This timeline accounts for interview results, medical fitness reports, protector of emigrants clearance, and visa processing through the embassy.",
                    },
                    {
                      q: "Is it safe to apply through your agency?",
                      a: "Absolutely. We are a fully licensed Overseas Employment Promoter (OEP) authorized by the Bureau of Emigration & Overseas Employment (BEOE), Government of Pakistan.",
                    },
                  ].map((faq, index) => (
                    <div
                      className="accordion-item mb-4 border-0 shadow-sm"
                      key={index}
                      style={{ borderRadius: "15px", overflow: "hidden" }}
                    >
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button ${index !== 0 ? "collapsed" : ""} fw-bold py-4`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#faq${index}`}
                          style={{
                            backgroundColor: "white",
                            boxShadow: "none",
                            fontSize: "1.1rem",
                            color: index === 0 ? "#86B817" : "#212529",
                          }}
                        >
                          <span className="text-primary me-3">
                            0{index + 1}.
                          </span>
                          {faq.q}
                        </button>
                      </h2>
                      <div
                        id={`faq${index}`}
                        className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                        data-bs-parent="#accordionFAQ"
                      >
                        <div
                          className="accordion-body bg-white pt-0 pb-4 px-5 text-muted"
                          style={{ lineHeight: "1.8" }}
                        >
                          <div className="border-start border-3 border-primary ps-4">
                            {faq.a}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* FAQ SECTION END */}
    </>
  );
};

export default FAQ;
